module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"switch":"Fran&ccedil;ais","taxes":"Property Taxes (France only)","title":"Christophe Moine\u0027s incredible website"},"fr":{"switch":"English","taxes":"Taxes fonci&egrave;res","title":"L\u0027incroyable site web de Christophe Moine"}}')
  delete Component.options._Ctor
}
